import { BlacklistedIdentifierFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";

export const fakeBlackListIdentifiers = (
  paperDocSiren: string,
  emailRepresentantLegal: string
): BlacklistedIdentifierFragmentFragment[] => [
  {
    element: {
      name: "Fiche entreprise Pappers",
      typeCode: "PappersFicheEntreprise",
      __typename: "Element",
    },
    identifier: {
      schemaIdentifier: {
        code: "SIREN",
        name: "SIREN",
        __typename: "SchemaIdentifier",
      },
      __typename: "Identifier",
      value: paperDocSiren,
      identifierType: {
        code: "SIREN",
        name: "SIREN",
        __typename: "IdentifierType",
      },
      id: "SWRlbnRpZmllcjo1NGYwZTYxNi0wMWQzLTQ2NmEtODVhZi04ZjYxMGFiZGNjYTQ=",
    },
    blacklistElement: {
      blacklist: {
        name: "SIRENs surveillés",
        code: "SIRENBlacklist",
        __typename: "Blacklist",
      },
      __typename: "BlacklistElement",
    },
    __typename: "BlacklistedCaseIdentifier",
  },
  {
    element: {
      name: "Représentant Légal",
      typeCode: "RepresentantLegal",
      __typename: "Element",
    },
    identifier: {
      schemaIdentifier: {
        code: "Email",
        name: "Email",
        __typename: "SchemaIdentifier",
      },
      __typename: "Identifier",
      value: emailRepresentantLegal,
      identifierType: {
        code: "Email",
        name: "Email",
        __typename: "IdentifierType",
      },
      id: "SWRlbnRpZmllcjowNjA5MTcyNi00NjgxLTQ2OTktYWY5Zi04YTcxNjY0NWM5MjY=",
    },
    blacklistElement: {
      blacklist: {
        name: "Emails surveillés",
        code: "EmailBlacklist",
        __typename: "Blacklist",
      },
      __typename: "BlacklistElement",
    },
    __typename: "BlacklistedCaseIdentifier",
  },
  {
    element: {
      name: "Entreprise",
      typeCode: "Entreprise",
      __typename: "Element",
    },
    identifier: {
      schemaIdentifier: {
        code: "Numera",
        name: "Numera",
        __typename: "SchemaIdentifier",
      },
      __typename: "Identifier",
      value: "2333",
      identifierType: {
        code: "Numera",
        name: "Numera",
        __typename: "IdentifierType",
      },
      id: "SWRlbnRpZmllcjplYWM3OTMyZC00ZTk3LTRlYzUtODYwNy03NTI2OGYyZDNkYjc=",
    },
    blacklistElement: {
      blacklist: {
        name: "Numeras surveillés",
        code: "NumeraBlacklist",
        __typename: "Blacklist",
      },
      __typename: "BlacklistElement",
    },
    __typename: "BlacklistedCaseIdentifier",
  },
  {
    element: {
      name: "Entreprise",
      typeCode: "Entreprise",
      __typename: "Element",
    },
    identifier: {
      schemaIdentifier: {
        code: "AdresseSiege",
        name: "Adresse siège",
        __typename: "SchemaIdentifier",
      },
      __typename: "Identifier",
      value: "7214 avenue Renée Santos",
      identifierType: {
        code: "Adresse",
        name: "Adresse",
        __typename: "IdentifierType",
      },
      id: "SWRlbnRpZmllcjplMjQyNzczOC1jN2ZhLTQ5OGUtYmMxNC00YzU3NDIwZjYyNmM=",
    },
    blacklistElement: {
      blacklist: {
        name: "Adresses de domiciliation",
        code: "AdresseDomiciliationBlacklist",
        __typename: "Blacklist",
      },
      __typename: "BlacklistElement",
    },
    __typename: "BlacklistedCaseIdentifier",
  },
  {
    element: {
      name: "Entreprise",
      typeCode: "Entreprise",
      __typename: "Element",
    },
    identifier: {
      schemaIdentifier: {
        code: "SIREN",
        name: "SIREN",
        __typename: "SchemaIdentifier",
      },
      __typename: "Identifier",
      value: "222333444",
      identifierType: {
        code: "SIREN",
        name: "SIREN",
        __typename: "IdentifierType",
      },
      id: "SWRlbnRpZmllcjo1NGYwZTYxNi0wMWQzLTQ2NmEtODVhZi04ZjYxMGFiZGNjYTQ=",
    },
    blacklistElement: {
      blacklist: {
        name: "SIRENs surveillés",
        code: "SIRENBlacklist",
        __typename: "Blacklist",
      },
      __typename: "BlacklistElement",
    },
    __typename: "BlacklistedCaseIdentifier",
  },
  {
    element: {
      name: "Expert comptable",
      typeCode: "ExpertComptable",
      __typename: "Element",
    },
    identifier: {
      schemaIdentifier: {
        code: "Email",
        name: "Email",
        __typename: "SchemaIdentifier",
      },
      __typename: "Identifier",
      value: "emma.andre@xxx.com",
      identifierType: {
        code: "Email",
        name: "Email",
        __typename: "IdentifierType",
      },
      id: "SWRlbnRpZmllcjozMTJjNGFkMy1lZjY2LTRkMDEtOGRiYy0wMTBhNDBhMGJlZjU=",
    },
    blacklistElement: {
      blacklist: {
        name: "Emails surveillés",
        code: "EmailBlacklist",
        __typename: "Blacklist",
      },
      __typename: "BlacklistElement",
    },
    __typename: "BlacklistedCaseIdentifier",
  },
];
